import {useIntl} from 'react-intl';
import * as store from '@/store';
import Icon, {IconSize} from '@/components/Icon';
import {CommentNumberSvg} from '@/icons';
import {IAiChatPanel, ICommentCount} from '@/interface';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import styles from './index.module.scss';
import classNames from 'classnames';
import {EDITOR_MODE} from '@/Constant';
import StatisticCount from './StatisticCount';
import {withAfterDomReady} from '@/components/AfterDomReady';
import {importAsyncComponent} from '@/utils/loadable';


interface IViewNumberProps {
    title: string;
    icon: React.FunctionComponent;
    number?: number;
}

// 未开启情况下的展示信息及评论数信息
function ViewNumber(props: IViewNumberProps) {
    const {title, icon, number = 0} = props;
    return (
        <Tooltip trigger={TooltipTrigger.Hover} content={title}>
            <div className={styles.countNum}>
                <Icon className={styles.icon} svg={icon} size={IconSize.LG} />
                <span>{number}</span>
            </div>
        </Tooltip>
    );
}

export interface IProps {
    isStatNumShow?: boolean;
    curDocCommentCount?: ICommentCount;
    docContentWidth?: {
        width: number;
        left: number;
    };
    documentMode?: EDITOR_MODE;
    aiChatPanel?: IAiChatPanel;
    docWordNum?: {
        totalWordCount: number;
        selectedWordCount?: number;
    };
    demoMode?: boolean;
}

const BottomBar: React.FC<IProps> = ({
    isStatNumShow,
    curDocCommentCount,
    docContentWidth,
    documentMode: mode,
    aiChatPanel,
    docWordNum,
    demoMode,
}) => {
    const intl = useIntl();
    const commentNum = (curDocCommentCount?.commentAllCount || 0) + (curDocCommentCount?.underlineCommentCount || 0);

    let rootStyle = {};
    if (docContentWidth) {
        rootStyle = {
            width: docContentWidth.width,
            left: docContentWidth.left,
        };
    }

    return (
        <div className={styles.bottomBarWrap}>
            <div
                className={classNames(
                    styles.bottomBar,
                    aiChatPanel?.isExpanded && styles.fitAiChat,
                    aiChatPanel?.isAiAssistant && styles.isAiAssistant
                )}
            >
                <div className={styles.root} style={rootStyle}>
                    <div className={styles.left}>
                    </div>
                    <div className={styles.placeholder}></div>
                    <div className={styles.right}>
                        {isStatNumShow ? (
                            <>
                                <StatisticCount
                                    docWordNum={docWordNum}
                                    documentMode={mode}
                                    demoMode={demoMode}
                                />
                                <ViewNumber
                                    icon={CommentNumberSvg}
                                    title={intl.formatMessage({id: 'commentsNumber'}, {number: commentNum})}
                                    number={commentNum}
                                />
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default store.connect([
    store.KEYS.IS_STAT_NUM_SHOW,
    store.KEYS.CUR_DOCUMENT_COMMENT_COUNT,
    store.KEYS.DOC_CONTENT_WIDTH,
    store.KEYS.DOCUMENT_MODE,
    store.KEYS.AI_CHAT_PANEL,
    store.KEYS.DOC_WORD_NUM,
    store.KEYS.DEMO_MODE,
])(BottomBar);
